import { useFocusEffect } from "expo-router";
import React, { useState, useEffect } from "react";
import { View } from "react-native";
import CurrencyInput from "react-native-currency-input";

import i18n from "@/locales/i18n";

interface InputAmountProps {
  control?: any;
  name: string;
  value?: string;
  handleChange?: (number: number) => void;
  handleReset?: (boolean: boolean) => void;
  resetValue: boolean;
  type?: string;
  error?: boolean;
  placeholder?: string;
  optional?: boolean;
  displayValue?: string;
}

export default function InputAmount(props: InputAmountProps) {
  const [amount, setAmount] = useState(0);
  const [clear, setClear] = useState(false);
  const [delimiter, setDelimiter] = useState(".");
  const [separator, setSeparator] = useState(",");
  const detectedLanguage = i18n.language;

  useFocusEffect(
    React.useCallback(() => {
      return () => {
        setAmount(0);
      };
    }, [])
  );

  useEffect(() => {
    if (detectedLanguage && detectedLanguage === "en") {
      setDelimiter(",");
      setSeparator(".");
    }
  }, [detectedLanguage]);

  useEffect(() => {
    props.handleChange && props.handleChange(amount);
  }, [amount]);

  useEffect(() => {
    if (props.resetValue) {
      setClear(true);
    }

    if (clear) {
      setAmount(0);
      setClear(false);
      props.handleReset(false);
    }
  }, [props.resetValue, clear]);

  return (
    <View>
      <CurrencyInput
        className="text-center border-b border-solid border-midgray w-80 h-14 text-black1 text-4xl"
        value={amount}
        keyboardType="numeric"
        onChangeValue={setAmount}
        delimiter={delimiter}
        separator={separator}
        precision={2}
        minValue={0}
      />
    </View>
  );
}
